import { jsx, jsxs } from "react/jsx-runtime";
const Discount = ({ className, color: colorProp = '#4B22F4', secondaryColor: secondaryColorProp = '#181B32', size = 32, ignoreColor })=>{
    const color = ignoreColor ? void 0 : colorProp;
    const secondaryColor = ignoreColor ? void 0 : secondaryColorProp;
    return /*#__PURE__*/ jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M50.8335 56.6667C46.6877 56.6667 43.3335 53.3125 43.3335 49.1667C43.3335 45.0208 46.6877 41.6667 50.8335 41.6667C54.9793 41.6667 58.3335 45.0208 58.3335 49.1667C58.3335 53.3125 54.9585 56.6667 50.8335 56.6667ZM50.8335 45C48.5418 45 46.6668 46.875 46.6668 49.1667C46.6668 51.4583 48.5418 53.3333 50.8335 53.3333C53.1252 53.3333 55.0002 51.4583 55.0002 49.1667C55.0002 46.875 53.1252 45 50.8335 45Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M29.1665 38.3333C25.0207 38.3333 21.6665 34.9792 21.6665 30.8333C21.6665 26.6875 25.0207 23.3333 29.1665 23.3333C33.3123 23.3333 36.6665 26.6875 36.6665 30.8333C36.6665 34.9792 33.2915 38.3333 29.1665 38.3333ZM29.1665 26.6667C26.8748 26.6667 24.9998 28.5417 24.9998 30.8333C24.9998 33.125 26.8748 35 29.1665 35C31.4582 35 33.3332 33.125 33.3332 30.8333C33.3332 28.5417 31.4582 26.6667 29.1665 26.6667Z",
                fill: secondaryColor
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M30.6248 57.1039L27.854 55.2497L49.4373 22.8539L52.2082 24.708L30.6248 57.1039Z",
                fill: color
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M61.6667 70H18.3333C14.6667 70 11.6667 67 11.6667 63.3333V57.75C4.83333 55.375 0 48.125 0 40C0 31.875 4.83333 24.625 11.6667 22.25V16.6667C11.6667 13 14.6667 10 18.3333 10H61.6667C65.3333 10 68.3333 13 68.3333 16.6667V22.25C75.1667 24.625 80 31.875 80 40C80 48.125 75.1667 55.375 68.3333 57.75V63.3333C68.3333 67 65.3333 70 61.6667 70ZM18.3333 13.3333C16.5 13.3333 15 14.8333 15 16.6667V24.7917L13.75 25.1042C7.70833 26.625 3.33333 32.8958 3.33333 40C3.33333 47.1042 7.70833 53.375 13.75 54.8958L15 55.2083V63.3333C15 65.1667 16.5 66.6667 18.3333 66.6667H61.6667C63.5 66.6667 65 65.1667 65 63.3333V55.2083L66.25 54.8958C72.2708 53.375 76.6667 47.1042 76.6667 40C76.6667 32.8958 72.2917 26.625 66.25 25.1042L65 24.7917V16.6667C65 14.8333 63.5 13.3333 61.6667 13.3333H18.3333Z",
                fill: color
            })
        ]
    });
};
const pictograms_Discount = Discount;
export default pictograms_Discount;
